/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ language: NonNullable<unknown> }} Lang_Suggestion_PromptInputs */

const en_lang_suggestion_prompt = /** @type {(inputs: Lang_Suggestion_PromptInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Prefer ${i?.language}?`)
};

const ar_lang_suggestion_prompt = /** @type {(inputs: Lang_Suggestion_PromptInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`هل تفضّل ${i?.language}؟`)
};

const bn_lang_suggestion_prompt = /** @type {(inputs: Lang_Suggestion_PromptInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`আপনি কি ${i?.language} পছন্দ করবেন?`)
};

const de_lang_suggestion_prompt = /** @type {(inputs: Lang_Suggestion_PromptInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Möchten Sie ${i?.language} verwenden?`)
};

const es_lang_suggestion_prompt = /** @type {(inputs: Lang_Suggestion_PromptInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`¿Prefieres ${i?.language}?`)
};

const fr_lang_suggestion_prompt = /** @type {(inputs: Lang_Suggestion_PromptInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Vous préférez ${i?.language} ?`)
};

const pt_lang_suggestion_prompt = /** @type {(inputs: Lang_Suggestion_PromptInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Prefere ${i?.language}?`)
};

const zh_lang_suggestion_prompt = /** @type {(inputs: Lang_Suggestion_PromptInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`更想使用${i?.language}吗？`)
};

const tr_lang_suggestion_prompt = /** @type {(inputs: Lang_Suggestion_PromptInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.language} kullanmak ister misiniz?`)
};

const ru_lang_suggestion_prompt = /** @type {(inputs: Lang_Suggestion_PromptInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Предпочитаете ${i?.language}?`)
};

const pl_lang_suggestion_prompt = /** @type {(inputs: Lang_Suggestion_PromptInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Wolisz język: ${i?.language}?`)
};

/**
* | output |
* | --- |
* | "Prefer {language}?" |
*
* @param {Lang_Suggestion_PromptInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const lang_suggestion_prompt = /** @type {((inputs: Lang_Suggestion_PromptInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Lang_Suggestion_PromptInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_lang_suggestion_prompt(inputs)
	if (locale === "bn") return bn_lang_suggestion_prompt(inputs)
	if (locale === "de") return de_lang_suggestion_prompt(inputs)
	if (locale === "es") return es_lang_suggestion_prompt(inputs)
	if (locale === "fr") return fr_lang_suggestion_prompt(inputs)
	if (locale === "pt") return pt_lang_suggestion_prompt(inputs)
	if (locale === "zh") return zh_lang_suggestion_prompt(inputs)
	if (locale === "tr") return tr_lang_suggestion_prompt(inputs)
	if (locale === "ru") return ru_lang_suggestion_prompt(inputs)
	if (locale === "pl") return pl_lang_suggestion_prompt(inputs)
	return en_lang_suggestion_prompt(inputs)
});